import React from 'react';
import './BrandLoader.css';

// The one loader used across the admin panel: the Gettimelam logo with a ring turning around it.
// `size` is the width in px; GlobalLoader shows it over the whole screen during API calls, pages use it for their own loading areas.
const BrandLoader = ({ size = 64, label = 'Loading' }) => (
    <span className="brand-loader" role="status" aria-label={label} style={{ '--bl-size': `${size}px` }}>
        <span className="brand-loader__ring" />
        <img className="brand-loader__logo" src={`${process.env.PUBLIC_URL}/loader-logo.png`} alt="" draggable="false" />
    </span>
);

export default BrandLoader;
